/**
 * Feature flags for Schedule/Calendar functionality.
 *
 * SCHEDULE_DATE_RANGE_FILTER:
 * When enabled, the Schedule query passes start/end date filters to the backend,
 * reducing payload size by only fetching events within the visible range.
 *
 * When disabled (default), the backend uses its default date bounds
 * (1 month before to 3 months after current date) and returns all events.
 *
 * Trade-offs:
 * - Enabled: Smaller payloads, but creates separate cache entries per date range
 * - Disabled: Larger payloads, but single cache entry that's easier to update
 *
 * Set to true once backend support is verified and cache behavior is acceptable.
 */
export const SCHEDULE_DATE_RANGE_FILTER = false;
